<!--仓库发起采购页面--其他商品 数量类型-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" style="width: 850px;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right" >&nbsp;&nbsp;&nbsp;&nbsp;</td>
          <td  style="padding-bottom: 10px" colspan="2">
            <el-radio-group v-model="isBackorder" size="mini" :fill="isBackorder?'#F56C6C':'#67C23A'">
              <el-radio-button :label="false">采购单</el-radio-button>
              <el-radio-button :label="true" >退货单</el-radio-button>
            </el-radio-group>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td width="120">
            <el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right"  width="80">类&nbsp;&nbsp;别：</td>
          <td  width="160">
            <CommonTree ref="treeSeed" :inputSize="'mini'" :defineDataSource="true" @bindData="bindData"
                        :treeWidth="450"
                        :onlyShowGroupType="false" :needTopNode="false" :onlySelectChild="true"
                        :treeHeight="300" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
          </td>
          <td align="right">供应商：</td>
          <td >
            <el-select v-model="pcustomerserial" placeholder="请选择" size="mini" filterable  @change="changepcu">
              <el-option
                v-for="item in ptableData"
                :key="item.customerserial"
                :label="item.deptname"
                :value="item.customerserial">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr class="noborder" style="display: none">
          <td align="right">订单号：</td>
          <td>系统自动生成</td>
          <td align="right">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</td>
          <td>{{controlData.adddate}}</td>
        </tr>
        <tr class="noborder">

          <td align="right" v-if="!ssotoken">供应号：</td>
          <td v-if="!ssotoken">
            <el-input v-model="tracknum" size="mini" ref="tracknum" placeholder="请输入供应商单号"
                      onfocus="this.select()"></el-input>
          </td>
          <!--<td align="right" width="80">跟踪号：</td>-->
          <!--<td>-->
            <!--<el-input v-model="logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请填写跟踪单号" style="width: 160px"-->
                      <!--onfocus="this.select()"></el-input>-->
          <!--</td>-->
          <td colspan="2" style="padding-left: 30px">{{pingpainame}}</td>
        </tr>
        <tr class="noborder">
          <td></td>
          <td></td>
          <td></td>
          <td>总数:{{totalnumber}}</td>
          <td></td>
          <td style="padding-left: 60px">
            <el-button size="mini" type="success" @click.stop.prevent="showGoodDetailSel()">选择商品
            </el-button>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>

              <el-table-column
                prop="seedcode"
                label="编码"
                align="center"
                width="130"
                header-align="center">
              </el-table-column>
              <el-table-column
              prop="seedname"
              label="名称"
              align="center"
              header-align="center">
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="数量"
                align="center"
                width="90"
                header-align="center">
                <template slot-scope="scope">
                  <el-input style="width: 100%" size="small" v-model="scope.row.totalnumber"
                            :ref='scope.row.id'
                            onfocus="this.select()"
                            @keyup.enter.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.down.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.up.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @change="numChange(scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="130">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger"
                             @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
        <tr class="noborder">
          <td>说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5">
            <textarea style="width: 100%;height: 40px" v-model="controlData.remark"></textarea>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="danger" size="mini" v-if="!isBackorder&&ssotoken" @click="saveDataNotoken">确认采购（不推送给供应商）</el-button>
      <el-button type="primary" @click="saveData" :loading="loading">{{isBackorder?'生成退货单':'生成采购单'}}</el-button>
    </div>
    <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode" :showCat="false" :isShowCheckBox="true"></JxcgooddetailSel>
    <StoreDetailListSupplySee ref="OrderSupplySee1" :showcostprice="false"></StoreDetailListSupplySee>
    <ewmPay ref="ewmPay1" @UnionPay="afterUnionPay" :ewmpre="'buyotherorderedit'" @CancelUnionPay="afterCancelUnionPay"></ewmPay>
    <BuyfromSupplyer ref="BuyfromSupplyer"></BuyfromSupplyer>
  </el-dialog>
</template>


<script>

  import {suppliers} from '@/api/set/externaldept';
  import {createGoodsbarcode} from '@/api/set/jxcgoodsbarcode';
  import {sortByKey} from '@/api/dateUtil';
  import {barcodePrint} from '@/api/file';
  import {isUGO} from '@/api/login';
  import ewmPay from './ewmPay';
  import {getRemark} from '@/plugin/ordercommon'
  import {login, createOrder,backOrder} from '@/api/ossi';
  import JxcgooddetailSel from '../../set/jxcgooddetail/JxcgooddetailSel';
  import {buyodersavedetail, SSOrelatedOrder} from '@/api/set/csagreement';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {listgoodsframe, getDetail, getGoodsTree} from '@/api/set/jxcgooddetail'
  import {loadSpecFrame} from '@/plugin/ordercommon'
  import {weiyimalist} from '@/api/set/jxcstoregoodsbarcode';
  import StoreDetailListSupplySee from '../../account/StoreDetailListSupplySee'
  import BuyfromSupplyer from '../buyagreement/BuyfromSupplyer';

  export default {
    name: 'BatchBuyorderDetailEdit',
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        ssoT:false,
        isBackorder:false,
        ssotoken:"",
        website:"",
        userInfoModel: {},
        data: '2',
        allSupply:false,
        didata: '',
        iddata: '',
        dialogFormVisible: false,
        title: "",
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        maxyear: yearnow,
        maxmonth: monthnow,
        catattributes:{},
        remark: '',
        cangkucode: '',
        cangkuname: '',
        payseedcodelist:'',
        tableData: [
          {column: []},
        ],
        unitguid: "",
        column: [],
        ptableData: [],
        controlData: {},
        showtitle1: "none",
        jxcstoreData: [],
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          seedinfo: "",
        },
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        seedcodeData: [],//选择类别后的商品
        seedcodes: '',
        pingpainame:'',
        tableData: [],
        loading: false,//防止多次提交
        totalnumber: 0,
        pcustomerserial: ''
      }

    },
    methods: {
      guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      },
      //回车跳入下一行
      validateCounts(row, index, e ,pre) {
        var keyCode = e.keyCode || e.which || e.charCode;
        if (keyCode == 40 || keyCode === 13) {//回车，下方向键
          this.$refs[pre+row.id].blur()
          if (this.tableData.length - 1 === index) {
            index = -1
          }
          this.$refs[pre + (index + 1)].focus();
        } else if (keyCode == 38) {//上方向键
          this.$refs[pre+row.id].blur()
          if (index === 0) {
            index = this.tableData.length
          }
          this.$refs[pre + (index - 1)].focus();
        }
      },
      //给tableData 添加 id，共回车使用
      indexMethod(index) {
        this.tableData[index].id = index
        return index + 1;
      },
      numChange(row) {
        if (parseFloat(row.totalnumber).toString() == 'NaN') {
          row.totalnumber = 0;
        }
        if (row.totalnumber < 0) row.totalnumber = -row.totalnumber ;
        this.totalNumber();
      },
      //购买总数
      totalNumber() {
        this.totalnumber = 0
        for (let i in this.tableData) {
          this.totalnumber = this.totalnumber + parseInt(this.tableData[i].totalnumber)
        }
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if(!this.form.seedcode){
          this.$message({
            message: '请选择类别',
            type: 'error'
          })
          return
        }
        this.$refs.JxcgooddetailSel.show({categorycode:this.form.seedcode,filltemplate:40})
        this.$refs.JxcgooddetailSel.bindGrid();
      },
      //选择商品之后执行
      afterSelectCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            //判读该商品是否属于
            if (this.tableData[j].seedcode == arr[i].seedcode ) {
              biaoji = 1
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              color:'',
              model:'',
              categorycode: arr[i].categorycode,
              totalnumber: 1,
              formproperty: '[{}]',
              packagesize:'',
              onlycode:'',
              barcodes:[]
            })
          }
        }

        this.totalNumber()
      },
      //删除明细
      handleDelete(index, row) {
        this.tableData.splice(index, 1)
        this.totalNumber()
      },
      //页面标题
      getTitle() {
        let result =  (this.userInfoModel.independentserial?this.userInfoModel.independentfdname:this.userInfoModel.tenantname)
        result += "采购订单"
        return result
      },
      changepcu(val) {
        this.ssotoken = ""
        for (let i in this.ptableData) {
          if (this.ptableData[i].customerserial == val) {
            this.controlData.pcustomerserial = this.ptableData[i].customerserial
            this.controlData.pcustomer = this.ptableData[i].deptname
            this.controlData.clinkman = this.ptableData[i].linkman
            this.controlData.clinkmantel = this.ptableData[i].linkmantel
            this.controlData.caddress = this.ptableData[i].address
            this.customerInitSSO();
            break;
          }
        }
      },
      customerInitSSO() {
        this.ssotoken = ""
        for (let i in this.ptableData) {
          if (this.ptableData[i].customerserial == this.controlData.pcustomerserial) {
            if (this.ptableData[i].usesso == 1 && this.ptableData[i].ssocode) {
              login({idencode: this.ptableData[i].ssocode, tenantid: this.userInfoModel.tenantid, independentserial: this.userInfoModel.independentserial}).then(loginres => {
                if (loginres.data.code == 0) {
                  this.ssotoken = loginres.data.msg;
                  this.website = loginres.data.website;
                } else {
                  this.$message({message: loginres.data.msg, type: 'error'})
                }
              });
            }
            break;
          }
        }
      },
      checktree1(guids, names, arr) {
        this.seedcodeData = []
        this.form.seedcode = guids
        this.form.seedname = names
        this.form.seedinfo = ";" + guids + "," + arr[0].parentId + ";"
        this.catattributes=arr[0].attributes;
        this.pingpainame=guids.length==12?(this.$refs.treeSeed.getNode(guids.substr(0, guids.length - 3)).label):'';
        if (this.form.seedname == "") {
          this.$message({
            message: '请选择类别',
            type: 'error'
          })
          return
        }
      },
      //判断是否有供应商
      geterweibiao() {
        this.ssotoken = ""
        this.pcustomerserial=""
        suppliers({categorycode: '', search: ""}).then((response) => {
          this.ptableData = response.data.obj
        })
      },
      //商品树
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType: true, categorystarts: '006'})
        })
      },
      //备注格式化
      getLiuYan(remark) {
        return getRemark(remark);
      },
      print1() {
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
        })
      },
      show() {
        this.dialogSeeVisible = true;
        this.geterweibiao();
      },
      //仓库选择后获取仓库名
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
      },
      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },
      saveDataNotoken(){
        this.saveData('notoken');
      },
      saveData(notoken) {
        //取出对应的表单详情和数量
        var arr = [];
        if (!this.controlData.pcustomerserial) {
          this.$message({
            message: '请选择供应商！',
            type: 'error'
          })
          return
        }
        if (!this.controlData.cangkucode) {
          this.$message({
            message: '请选择仓库！',
            type: 'error'
          })
          return
        }
        var seedcodelist = ';'
        for (let i in this.tableData) {
          if (this.tableData[i].totalnumber && this.tableData[i].totalnumber != 0) {

            if (seedcodelist.indexOf(';' + this.tableData[i].seedcode + ';') == -1)
              seedcodelist += this.tableData[i].seedcode + ';';

            arr.push({
              seedcode: this.tableData[i].seedcode,
              seedname: this.tableData[i].seedname,
              P: this.tableData[i].totalnumber,
              formproperty: '[{}]',
              packagesize: '',
            })

          } else {
            this.$message({
              message: this.tableData[i].seedname + ',没有填写数量！',
              type: 'error'
            })
            return
          }
        }
        if (arr.length <= 0) {
          this.$message({
            message: '请选择商品！',
            type: 'error'
          })
          return
        }

        if (this.isBackorder) {
          for (let i in arr) {
            if (parseInt(arr[i].P) > 0) {
              arr[i].P = -arr[i].P;
            }
          }
        }
        this.ssoT=true;
        var ssoTok=this.ssotoken;
        if(notoken&&notoken=='notoken') {
          ssoTok = "";
          this.ssoT = false;
        }
        if (ssoTok&&!this.isBackorder) {//需要向供应商发起采购 (退货单不发起)
          var ckInfo = {};
          for (let i in this.jxcstoreData) {
            if (this.jxcstoreData[i].cangkucode == this.controlData.cangkucode) {
              ckInfo = this.jxcstoreData[i];
            }
          }
          var buyForms='['
          for (let j in arr) {
            if(buyForms!='[')
              buyForms+=',';
            buyForms+='{"seedcode":"'+arr[j].seedcode+'",'
            buyForms+='"Number":'+arr[j].P+'}'
          }
          buyForms+=']';
          var remarkStr='[]';
          if(this.controlData.remark){
            remarkStr='[{"msg":"' + this.controlData.remark + '","date":"' + this.CurentTime() + '","uname":"' + this.userInfoModel.uname + '","type":"客户留言"}]';
          }
          createOrder({
            uname: this.userInfoModel.uname,
            uguid: this.userInfoModel.uguid,
            linkman: ckInfo.applyby,
            linkmantel: ckInfo.tel,
            deliverymode: '配送',
            deliveryaddress: ckInfo.adressdetail,
            formproperty: buyForms,
            remark: remarkStr,
          }, this.ssotoken).then(response => {
            var OrderData = response.data;
            if(OrderData.price) {
              var priceList = OrderData.price;//{商品编码:价格} 只有一个商品
              for (let j in arr) {
                arr[j].gysprice = priceList[this.form.seedcode]
              }
            }
            this.tracknum = OrderData.erpserial;
            if (OrderData.code == 0) {
              this.postBuyData(arr, '上游订单已生成，供应商单号：' + this.tracknum,seedcodelist);
            } else {
              if (OrderData.groupguid) {//打开支付页面
                if (!response.data.paytype == 'unionpay') {
                  this.$message({message: '尚未开通支付通道！', type: 'error'});
                  return;
                }
                OrderData.postdata = arr;
                this.payseedcodelist=seedcodelist;
                this.$refs.ewmPay1.show(OrderData, this.ssotoken);
              } else {
                this.$message({
                  message: response.data.msg ? response.data.msg : '提交的商品不存在！',
                  type: 'error'
                })
                this.loading = false
              }
            }
          });
        } else {
          this.postBuyData(arr, '保存成功！', seedcodelist);
        }
      },
      postBuyData(arr, msg,seedcodelist) {
        this.loading = true
        buyodersavedetail({
          jxcforms: JSON.stringify(arr),
          map: JSON.stringify({
            pcustomerserial: this.controlData.pcustomerserial,
            pcustomer: this.controlData.pcustomer,
            cangkuname: this.controlData.cangkuname,
            cangkucode: this.controlData.cangkucode,
            address: this.controlData.address,
            linkman: this.controlData.linkman,
            linkmantel: this.controlData.linkmantel,
            seedcode: this.form.seedcode,
            seedname: this.form.seedname,
            seedinfo: this.form.seedinfo,
            remark: this.controlData.remark ? this.controlData.remark : '',
            tracknum: this.tracknum.trim(),//供应商单号
            isdistribute: '40',//镜架仓库录入的入库单
            logisticstracknum: this.logisticstracknum.trim(),//跟踪单号
            invoicesource:1,//待审核
            status: 810,
            seedcodelist: seedcodelist
          })
        }).then(response => {
          if (response.data.code == 0) {
            if (this.ssotoken&&this.ssoT) {
              SSOrelatedOrder({
                erpserial: this.tracknum.trim(), parenterpserial: response.data.obj.erpserial, uname: '客户采购单号',customername:this.controlData.cangkuname.replace('仓库','')
              }, this.ssotoken).then(response => {
              })
            }
            this.$message({
              message: msg,
              type: 'success'
            })
            this.$emit('bindGrid');
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
            this.loading = false
          }
          this.dialogSeeVisible = false;
          //刷新列表
        });
      },
      afterUnionPay(row){
        this.postBuyData(row.postdata, '支付成功！上游订单已生成，供应商单号：' + this.tracknum + '',this.payseedcodelist);
      },
      afterCancelUnionPay(row){//撤销支付
        backOrder({erpserial: row.erpserial}, this.ssotoken).then(resDel => {
          this.loading = false;
        });
      },
      initData(row) {
        this.initForm();
        if (row == null)
          return;
        this.controlData.cangkucode = row.cangkucode;
        this.controlData.cangkuname = row.cangkuname;

        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
          this.form.bookstr = ""
          this.form.seedcode = ""
          this.form.seedname = ""
          this.form.seedinfo = ""
          this.catattributes={}
        }
        this.index = -99
        this.form.seedcode = ''
        this.form.seedname = ''
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.pcustomerserial=''
        this.ptableData=[]
        this.isBackorder=false;
        this.form.seedname=''
        this.form.seedcode=''
        this.controlData.pcustomerserial = ''
        this.controlData.pcustomer =''
        this.controlData.remark='';
        this.groupguid = ""
        this.column = []
        this.ssotoken = ""
        this.tableData = []
        this.unitguid = ""
        this.tracknum = ''
        this.logisticstracknum = ''
        this.loading = false
        this.totalnumber = 0
      },
      CurentTime()
      {
        var now = new Date();

        var year = now.getFullYear();       //年
        var month = now.getMonth() + 1;     //月
        var day = now.getDate();            //日

        var hh = now.getHours();            //时
        var mm = now.getMinutes();          //分

        var clock = year + "-";

        if(month < 10)
          clock += "0";

        clock += month + "-";

        if(day < 10)
          clock += "0";

        clock += day + " ";

        if(hh < 10)
          clock += "0";

        clock += hh + ":";
        if (mm < 10) clock += '0';
        clock += mm;
        return(clock);
      },
    },
    mounted() {
      let temp = localStorage.getItem("hpapi_userInfoModel")
      if (temp) {
        this.userInfoModel = JSON.parse(temp);
      }
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
        this.controlData.cangkucode = this.jxcstoreData[0].cangkucode;
        this.changename(this.controlData.cangkucode);
      })

    },

    components: {
      JxcgooddetailSel,
      BuyfromSupplyer,
      StoreDetailListSupplySee,
      ewmPay
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/testorder/buyagreement/OtherBuyorderDetailEdit.vue